import React from 'react';
import { createContainer } from '@dbk-legacy/muster/react';

import merge from 'lodash/merge';
import identity from 'lodash/identity';
import flow from 'lodash/flow';

import Error from '../../../../components/common/error';
import { LoadingCircle } from '../../../../components/common/loading';

import SingleTransaction from './single-transaction';

export const defaultTransactionFragment = {
  tradeDate: true,
  valueDate: true,
  tradeNumber: true,
};
 
export default function singleTransactionFactory({
  assetCategory,

  component = SingleTransaction,
  transactionFragment = defaultTransactionFragment,
  transactionFragmentExtend,
  positionFragmentExtend = {},

  mapper = identity,
}) {
  let resultingTransactionFragment = transactionFragment;

  if (transactionFragmentExtend) {
    resultingTransactionFragment = merge(
      {},
      resultingTransactionFragment,
      transactionFragmentExtend
    );
  }

  return createContainer(
    {
      $renderError: () => <Error />,
      $renderLoading: () => <LoadingCircle isPage={true}/>,
      $queries: {
        portfolio: {
          referenceCurrency: true,
          [assetCategory]: {
            static: {
              transactions: {
                detailsGroups: true,
              },
            },
          },
        },
       transact:{
          isEmpty: true,
          setIsEmpty: { $set: 'isEmpty' },
          getAdvices : { $call: 'getTransactionAdvices'},
        },
        i18n: {
         messages: true,
        },
        ui: {
          positions: {
            [assetCategory]: {
              currentPosition: {
                ...positionFragmentExtend,

                currency: true,
                name: true,

                transactions: {
                  $type: 'list',
                  $range: { from: 0, to: 0 },
                  $node: resultingTransactionFragment,
                },
              },
            },
          },
        },
      },
    },
    flow(
      mapper,
      ({ portfolio, ui, transact, i18n }) => ({
        defaultCurrency: ui.positions[assetCategory].currentPosition.currency || portfolio.referenceCurrency,
        rows: ui.positions[assetCategory].currentPosition.transactions,
        detailsGroups: portfolio[assetCategory].static.transactions.detailsGroups,
        header: ui.positions[assetCategory].currentPosition.name,
        transact, i18n,
      })
    )
  )(component);
}
